module.exports = __webpack_public_path__ + "img/lessonpre_arrow_down_grey.ffc62b7e.svg";